module.exports = __webpack_public_path__ + "static/Manatee-fdda8bbbd42238a87240e2f047132bc9.jpg";